module.exports = __webpack_public_path__ + "static/media/coaching-training.1163fcde.png";